

























import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power2,
    TimelineMax,
} from 'gsap';

import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "FullimgFloatText",
})
export default class FullimgFloatText extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    @Prop() public controller!: any | null;
    @Prop() public controller1!: any | null;

    public mounted() {

        const tl1 = new TimelineMax()
            .staggerFrom('.fullimg-wrap .tabimg', 1, {
                y: 100,
                autoAlpha: 0,
                scale: 1.25,
                overflow: 'hidden',
                ease: Power2.easeOut,
                clearProps: 'all'
            })
            .staggerFrom('.text-wrap', 1, {
                display: 'none',
                // delay: .5,
                y: 80,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.2, '-=.5')
            .staggerFrom('.text-wrap h2', 1, {
                y: 50,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.2, '-=.5')
            .staggerFrom('.text-wrap p', 1, {
                y: 30,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.2, 1.5)

        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
                triggerElement: ".fullimg-block",
                reverse: false,
                // duration: 1000,
                //triggerHook: "onEnter"
            })
            .setTween(tl1)
            .addTo(controller);

        // const tl2 = new TimelineMax()
        //     .staggerFrom('.text-wrap', 1, {
        //         opacity: 0,
        //         delay: 1.5,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     }, 0.2)
        //     .staggerFrom('.text-wrap h2', 1, {
        //         y: 50,
        //         autoAlpha: 0,
        //          delay: 1.8,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     }, 0.2)
        //     .staggerFrom('.text-wrap p', 1, {
        //         y: 30,
        //         autoAlpha: 0,
        //          delay: 1.9,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     }, 0.2, 0.2)
        // const controller1 = new ScrollMagic.Controller();

        // const scene1 = new ScrollMagic.Scene({
        //         triggerElement: ".text-wrap",
        //         reverse: false,
        //         //triggerHook: "onEnter"
        //     })
        //     .setTween(tl2)
        //     .addTo(controller1);

        // const tl3 = new TimelineMax()
        //     .from('.title-color', 1, {
        //         autoAlpha: 0,
        //         y: 200,
        //         delay: .5,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     })
        // const controller2 = new ScrollMagic.Controller();

        // const scene2 = new ScrollMagic.Scene({
        //         triggerElement: ".title-color",
        //         reverse: false,
        //         //triggerHook: "onEnter"
        //     })
        //     .setTween(tl3)
        //     .addTo(controller2);

        // const tl4 = new TimelineMax()
        //     .from('.text-wrap p', 1, {
        //         autoAlpha: 0,
        //         y: 200,
        //         delay: .8,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     })
        // const controller3 = new ScrollMagic.Controller();

        // const scene3 = new ScrollMagic.Scene({
        //         triggerElement: ".text-wrap p",
        //         reverse: false,
        //         //triggerHook: "onEnter"
        //     })
        //     .setTween(tl4)
        //     .addTo(controller3);

    }
}
